import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { PageWithLayout } from '../containers/page';


class PagesPage extends Component {
    constructor(props) {
        super(props);

        this.registerSocketIOEvents = this.registerSocketIOEvents.bind(this);
        this.handleDeletePrompt = this.handleDeletePrompt.bind(this);
        this.state = {
            pages: []
        };
    }


    componentDidMount() {
        this.props.handleLoader(true);

        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }

       
    }

    componentDidUpdate(prevProps) {
        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }
    }

    registerSocketIOEvents() {
        if (this.state._registeredEvents)
            return;

        this.setState({
            _registeredEvents: true
        });



        this.props.socketIOClient.on('pages', (data) => {
            this.props.handleLoader(null);

            console.log(data);
            this.setState({
                pages: data
            });
        });


        this.props.socketIOClient.emit('pages', {});
    }


    componentWillUnmount(){ if (!this.props.socketIOClient) return;
        this.props.socketIOClient.removeAllListeners("pages");
    }

    handleDeletePrompt(answer, val) {
        console.log(val);
        if (answer) {
            this.props.socketIOClient.emit('deletePage', { page: val});
            this.props.openDeletePrompt(null, null);

        } else {
            this.props.openDeletePrompt(null, null);
        }
    }

    render() {

        return (
            <div className="content">
            {

                (!this.props.uData && !localStorage.uData) && <Redirect to='/login' />
      
              }
                <div className="panel panel-list">
                    <div>

                        <div className="title">
                            <h1>{this.props.translate('Pages')}</h1>

                            <div className="button-wrap">
                                <Link to={`/pages/new`} className="button" >{this.props.translate('Add new page')}</Link>
                            </div>
                            <h6>{this.props.translate('List of pages')}</h6>



                        </div>


                        <div className="table">
                            <table>
                            <tr className="text-row">
                                    <th>{this.props.translate('Title')}</th>
                                    <th>{this.props.translate('Alias')}</th>
                                    <th className="action-head">{this.props.translate('Action')}</th>
                                </tr>

                                {
                                    this.state.pages.map((page) => {
                                        return (
                                            <tr className="text-row">
                                            <td>{page.title}</td>
                                                <td>{page.alias}</td>
                                                <td>
                                                <Link to={`/pages/${page._id}`} className="button" ><i className="mdi mdi-pencil"></i> </Link>
                                                    <button className="button" onClick={() => this.props.openDeletePrompt(page._id, this.handleDeletePrompt)}><i className="mdi mdi-delete"></i> </button>
                                                </td>
                                            </tr>


                                        )
                                    }
                                    )}

                            </table>

                        </div>


                    </div>

                </div>


            </div>
        );
    }
}

export default PageWithLayout(PagesPage);


// WEBPACK FOOTER //
// ./src/views/pagesPage.js